// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1iQ4r","validationTips":"StatementDescriptor_validationTips__33jXf"};